var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.1,14h-38.3v4h38.3c1.03,0,1.9.65,1.9,1.43v70.57h-22.43c-.33,1.18-.84,2.31-1.56,3.34-.16.23-.35.45-.52.66h28.51V19.43c0-2.99-2.65-5.43-5.9-5.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.55,84.52l-17.6-47.37c-.1-.31-.15-.63-.15-.95V12h1.2c1.1,0,2-.9,2-2s-.9-2-2-2h-20c-1.1,0-2,.9-2,2s.9,2,2,2h1.2v24.2c0,.32-.05.64-.12.86l-17.63,47.46c-.81,2.19-.51,4.63.82,6.54,1.3,1.87,3.34,2.95,5.59,2.95h40.28c2.25,0,4.29-1.07,5.59-2.95,1.33-1.91,1.63-4.35.82-6.54ZM29.87,38.36c.22-.7.34-1.43.34-2.16V12h9.6v24.2c0,.74.11,1.46.37,2.25l3.55,9.55h-17.43l3.58-9.64ZM26.87,82.97c-1.34,0-2.43-1.12-2.43-2.5s1.09-2.5,2.43-2.5,2.43,1.12,2.43,2.5-1.09,2.5-2.43,2.5ZM30.31,64.77c-2.21,0-4-1.79-4-4s1.79-4,4-4,4,1.79,4,4-1.79,4-4,4ZM41.59,81.36c-4.14,0-7.5-3.36-7.5-7.5s3.36-7.5,7.5-7.5,7.5,3.36,7.5,7.5-3.36,7.5-7.5,7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83,22h-35.2v14.03l10.2,27.45v-20.98c-3.87,0-7-3.13-7-7s3.13-7,7-7c1.96,0,3.73.81,5,2.11,1.27-1.3,3.04-2.11,5-2.11,3.87,0,7,3.13,7,7s-3.13,7-7,7v21c3.87,0,7,3.13,7,7s-3.13,7-7,7c-1.96,0-3.73-.81-5-2.11-.14.14-.28.27-.43.4l2.73,7.33c.35.94.55,1.9.64,2.88h18.06V23c0-.55-.45-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause2);
export default __webpack_public_path__ + "static/media/cause_2.9422968931314607de8dc53d8eb1a962.svg";
export { ForwardRef as ReactComponent };